import Vue from 'vue'

export default window.HHEvents = new class {
	constructor() {
		this.vue = new Vue();
		this.DISPLAY_BOARD = 'displayBoard';
		this.GAME_OVER = 'gameOver';
		this.ERROR = 'error';
		this.INITIATE_PLAYER_TURN = 'initiatePlayerTurn';
		this.LOADING_END = 'loadingEnd';
		this.LOADING_START = 'loadingStart';
		this.TOGGLE_GRID = 'toggleGrid';
		this.UPDATE_BOARD = 'updateBoard';
	}

	fire(event, data = null) {
		//console.log('EVENT', event, data);
		this.vue.$emit(event, data);
	}

	listen(event, callback) {
		this.vue.$on(event, callback);
	}
}
